<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6">
        <span
          ><v-icon small left>mdi-information-outline</v-icon>Banka hesap
          parametrelerinizi ve taksitlerinizi buradan yönetebilirsiniz</span
        >
      </div>
      <div class="col-lg-6 text-end">
        <v-btn
          color="success darken-2"
          text
          small
          @click="openBankParametersDialog('new')"
        >
          <v-icon small left>mdi-plus</v-icon>
          YENİ PARAMETRE EKLE
        </v-btn>
      </div>
    </div>
    <v-row v-if="!bankParametersListLoading">
      <v-col
        v-for="item in bankParametersList"
        :key="item.id"
        cols="12"
        sm="12"
        md="6"
        lg="4"
      >
        <v-card
          class="bg-secondary-900"
          ripple
          outlined
          solo
          hover
          min-height="220"
        >
          <v-card-text class="text-center justify-center p-0">
            <img style="width: 250px; height: 150px" :src="item.logoPath" />
          </v-card-text>
          <v-card-actions>
            <v-btn color="gray" @click="openBankParametersDialog('new', item)"
              >PARAMETRELER</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="gray" @click="openBankInstallmentDialog('edit', item)"
              >TAKSİTLER</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        class="d-flex flex-column justify-content-center align-items-center"
      >
        <b-spinner
          variant="primary"
          size="xl"
          label="Text Centered"
        ></b-spinner>
        <span class="fs-4 fw-medium">
          {{ "Yükleniyor" }}
        </span>
      </v-col>
    </v-row>
    <EditBankParametersDialog
      :bankParameterProp="bankParameterProp"
      :processType="processType"
      :showDialog="editBankParametersDialog"
      @dialogChange="(data) => (editBankParametersDialog = data)"
    ></EditBankParametersDialog>
    <EditBankInstallmentDialog
      :bankInstallmentProp="bankInstallmentProp"
      :processType="processType"
      :showDialog="editBankInstallmentDialog"
      @dialogChange="(data) => (editBankInstallmentDialog = data)"
      @installmentChange="reloadPage"
    ></EditBankInstallmentDialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import EditBankParametersDialog from "@/components/management/payment-settings/dialogs/EditBankParametersDialog.vue";
import EditBankInstallmentDialog from "@/components/management/payment-settings/dialogs/EditBankInstallmentDialog.vue";

export default {
  components: {
    EditBankInstallmentDialog,
    EditBankParametersDialog,
  },

  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("bank", [
      "bankParametersList",
      "bankParametersListHeaders",
      "bankParametersListLoading",
    ]),
  },
  async mounted() {
    await this.checkoutLogin();
    await this.fetchBankParametersList();
  },
  data() {
    return {
      editBankInstallmentDialog: false,
      editBankParametersDialog: false,
      bankParameterProp: null,
      bankInstallmentProp: null,
      processType: null,
      currentPage: 1,
      perPage: 10,
    };
  },
  methods: {
    ...mapActions("virtualPayment", ["checkoutLogin"]),
    ...mapActions("bank", ["fetchBankParametersList", "bankParameterDelete"]),
    openBankParametersDialog(processType, data = null) {
      this.bankParameterProp = null;
      this.bankParameterProp = data;
      this.processType = processType;
      this.editBankParametersDialog = true;
    },
    openBankInstallmentDialog(processType, data = null) {
      this.bankInstallmentProp = data;
      this.processType = processType;
      this.editBankInstallmentDialog = true;
    },
    async reloadPage(item) {
      await this.fetchBankParametersList();
      let newList = this.bankParametersList.find((e) => e.id === item);
      this.bankInstallmentProp = newList;
    },
  },
  watch: {},
};
</script>
